import { useMemo } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export function useFirestoreTimestamp(timestamp, options) {
  const date = useMemo(() => {
    if (!timestamp || typeof timestamp._seconds !== "number") return null;
    return new Date(timestamp._seconds * 1000);
  }, [timestamp]);

  const formattedDate = useMemo(() => {
    if (!date) return "";
    if (options?.relative) {
      return dayjs(date).fromNow();
    }
    return dayjs(date).format(options?.format || "YYYY-MM-DD HH:mm:ss");
  }, [date, options?.format, options?.relative]);

  return { date, formattedDate };
}

export const useFormattedDate = (date) => {
  return useMemo(() => {
    const d = new Date(date);
    return isNaN(d.getTime()) ? "-" : d.toLocaleDateString();
  }, [date]);
};
